import { RedoBadgeColor } from "@redotech/arbiter/badge/redo-badge";

export function shippingStatusToBadgeColor(status: string): RedoBadgeColor {
  switch (status) {
    // EasyPost confirmed that  "pre_transit" and "unknown" are interchangeable and can be treated as the same
    case "pre_transit":
    case "unknown":
      return "indigo";
    case "in_transit":
      return "brand";
    case "out_for_delivery":
      return "warning";
    case "delivered":
      return "success";
    case "available_for_pickup":
      return "purple";
    case "return_to_sender":
      return "blue";
    case "cancelled":
      return "orange";
    case "failure":
    case "error":
      return "error";
    default:
      return "gray";
  }
}
